
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/BlogList",
      function () {
        return require("private-next-pages/BlogList.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/BlogList"])
      });
    }
  